module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0001fb7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/AccountMov/Edit/EditForm.vue
// module id = 951
// module chunks = 1